import DOMPurify from 'dompurify';

/**
 * Sanitize stored discharge-summary HTML before rendering.
 *
 * Discharge `content` is attacker-influenced (AI output, imports, vet edits) and
 * is fed to ReactQuill (which assigns it via innerHTML / dangerouslyPasteHTML)
 * and to `dangerouslySetInnerHTML` in the print view. Without sanitization an
 * `<img src=x onerror=...>` payload executes in any viewer's browser and can
 * steal the Firebase ID token from IndexedDB → full account takeover
 * (XSS-VULN-01). The backend now sanitizes on write, but legacy rows stored
 * before that fix still need this client-side guard.
 *
 * The allow-list mirrors the discharge PDF template + the ReactQuill toolbar
 * output so legitimately-formatted summaries render identically. DOMPurify also
 * strips `javascript:`/event-handler attributes by default.
 */
const ALLOWED_TAGS = [
  'p', 'br', 'hr', 'span', 'div',
  'strong', 'b', 'em', 'i', 'u', 's', 'sub', 'sup', 'blockquote',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li',
  'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th',
  'header', 'footer', 'section', 'a', 'img',
];

const ALLOWED_ATTR = [
  'style', 'class', 'href', 'target', 'rel', 'src', 'alt', 'colspan', 'rowspan',
];

export function sanitizeDischargeHtml(html: string | null | undefined): string {
  return DOMPurify.sanitize(html || '', { ALLOWED_TAGS, ALLOWED_ATTR });
}
